import { render, staticRenderFns } from "./AdjustDetail.vue?vue&type=template&id=7d20ac80&scoped=true&"
import script from "./AdjustDetail.vue?vue&type=script&lang=js&"
export * from "./AdjustDetail.vue?vue&type=script&lang=js&"
import style0 from "./AdjustDetail.vue?vue&type=style&index=0&id=7d20ac80&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d20ac80",
  null
  
)

export default component.exports